import React from 'react'
import Card from 'components/Card/Card.jsx'
// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles'

import Typography from '@material-ui/core/Typography'
import { titleCase, localTime, howLong, logger } from '../utility/utility'

// display signer component
const signerStyles = {
  card: {
    width: '100%',
    border: '1px solid grey',
    height: 'auto', // browser won't calculate height if using percentage unless the parent set a fixed value, so for height, better just let it go
    margin: '3px 0px' // card has the defualt to be 30px for both up/bot
  },
  indetentation: {
    textIndent: '2em'
  },
  content: {
    marginLeft: '5px',
    marginRight: '10px',
    fontWeight: 'bold',
    color: '#26a69a'
  }
}
const CommentTemplate = props => {
  const { classes, comments, timeEllapsed } = props
  if (comments) logger(`[Comments][render]:`, comments, true)
  return comments ? (
    <Card className={classes.card}>
      {comments.map((c, key) => {
        const { user, comment, wroteOn } = c
        // console.log(c)
        return (
          <div key={`comment-${key}`} style={{ display: 'block' }}>
            <div style={{ display: 'flex' }}>
              <Typography variant='caption' className={classes.content} noWrap>
                {user ? '[' + titleCase(user.name) + ']' : <p />}
              </Typography>
              <Typography variant='caption'>
                {isNaN(timeEllapsed) ? howLong(wroteOn) + ', ' : ''}
                {localTime(wroteOn)}
              </Typography>
            </div>
            <div style={{ display: 'block' }}>
              <Typography variant='body2' className={(classes.content, classes.indetentation)} gutterBottom>
                {comment ? comment : <p />}
              </Typography>
            </div>
          </div>
        )
      })}
    </Card>
  ) : (
    ''
  )
}

export default withStyles(signerStyles)(CommentTemplate)
